// Historical wrapper — the reader-facing layout has moved to `ReaderLayout`
// which introduces a sidebar/topbar design that mirrors the admin panel.
// Keeping this file so existing imports (`import Layout from '../components/Layout'`)
// continue to work without touching every route.
import ReaderLayout from './ReaderLayout';

const Layout = ({ children }) => <ReaderLayout>{children}</ReaderLayout>;

export default Layout;
